import React from 'react';
import { Button, Layout } from 'antd';
import './AppFooter.scss';
import { t } from '../../../../../helpers/i18n';
import { useElementRect } from 'v2/util/hook/useElementRect';

const { Footer } = Layout;

export interface AppFooterProps {
  onCancel: () => void;
  onCreateNew: () => void;
}

const AppFooter: React.FC<AppFooterProps> = props => {
  const projectFormWidth = useElementRect('create-project-form-container')?.width

  return (
    <Footer className="create-project-footer">
      <Button
        onClick={props.onCancel}
        className="create-project-footer-cancel-button"
      >
        {t('cancel')}
      </Button>
      <Button
        onClick={props.onCreateNew}
        type="primary"
        className="create-project-footer-new-button"
      >
        {t('create_project_save_project')}
      </Button>
      <div style={{ width: (window.innerWidth - (projectFormWidth ?? 0)) / 2 }} />
    </Footer>
  );
};

export default AppFooter;
